/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';

export const SchemaPublishRequest: core.serialization.Schema<
    serializers.SchemaPublishRequest.Raw,
    Truvity.SchemaPublishRequest
> = core.serialization.object({
    slug: core.serialization.string().optional(),
    version: core.serialization.number().optional(),
});

export declare namespace SchemaPublishRequest {
    export interface Raw {
        slug?: string | null;
        version?: number | null;
    }
}
